
import { Component, Vue, Prop} from 'vue-property-decorator';

import Form5ProcessHeader from "@/components/process/Form5/components/Form5ProcessHeader.vue";
import { form5StatusInfoType } from '@/types/Information/Form5';

@Component({
    components:{
        Form5ProcessHeader
    }
})
export default class ErrorSubmitForm5 extends Vue {
    
    @Prop({required: true, default:" "})
    errMsg!: string;

    stepsCompleted = {} as form5StatusInfoType;  
    mountedData = false;     

    mounted() {
        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false,
            thirdError:true
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }

    public contactUs(){
        const ContactButton = document.getElementsByName("contact-us");
        if(ContactButton[0]) ContactButton[0].click()
    }
}
